import { Alert } from 'antd';
import { Button } from '@dynamika-shared/ui/Button/Button';
import { FC } from 'react';
import { twMerge } from '@utils/twMerge';
import { AlertIcon } from '@dynamika-shared/ui/icons';

type UnscheduledVisitOrderNotificationProps = {
  status: 'warning' | 'success';
  onClick: (e: React.MouseEvent) => void;
};

export const UnscheduledVisitOrderNotification: FC<
  UnscheduledVisitOrderNotificationProps
> = ({ status, onClick }) => {
  const config = {
    warning: {
      description:
        'No visit order defined for specific visit. Please place the visit in the right position, before completing visit data QC.',
      buttonText: 'Confirm Visit Order',
      classNames: 'border-redOrange border-opacity-40 !bg-seashell',
      iconClassName: '!text-vermilion',
    },
    success: {
      description:
        'You can still update this visits orderBefore any readings have been generated.',
      buttonText: 'Update Visit Order',
      classNames: 'border-yellowGreen border-opacity-40 !bg-honeydew',
      iconClassName: '!text-yellowGreen',
    },
  };

  const { description, buttonText, classNames, iconClassName } = config[status];

  return (
    <Alert
      description={description}
      type={status}
      showIcon
      icon={<AlertIcon className={twMerge('mr-1 h-2 w-2', iconClassName)} />}
      className={twMerge('items-center p-1.5 font-medium mb-2', classNames)}
      action={
        <div onClick={e => e.stopPropagation()}>
          <Button
            type='text'
            onClick={onClick}
            className={twMerge(
              '!pb-0 !pt-0 !text-1424',
              status === 'warning' ? 'text-vermilion' : 'text-yellowGreen'
            )}
          >
            {buttonText}
          </Button>
        </div>
      }
    />
  );
};
